import { Reveal } from '../components/Reveal'
import { Kicker } from '../components/Kicker'
import { FluidHeading } from '../components/FluidHeading'

const SERVICES = [
  {
    title: 'Tráfego Pago & Performance',
    desc: 'Planejamento, gestão e otimização de campanhas no Meta Ads e Google Ads com foco em gerar oportunidades reais para o seu negócio.',
    highlight: true,
  },
  {
    title: 'Estratégia Digital',
    desc: 'Analisamos mercado, público, oferta e jornada para construir estratégias que façam sentido para cada objetivo.',
  },
  {
    title: 'Criativos & Design',
    desc: 'Criativos para anúncios, peças digitais e materiais desenvolvidos para chamar atenção, comunicar e gerar ação.',
  },
  {
    title: 'Sites & Landing Pages',
    desc: 'Sites e páginas pensados não apenas para serem bonitos, mas para transformar acessos em contatos e vendas.',
  },
  {
    title: 'Social Media & Conteúdo',
    desc: 'Estratégia, planejamento e criação de conteúdo para construir presença, autoridade e fortalecer a marca no digital.',
  },
  {
    title: 'Branding & Identidade Visual',
    desc: 'Construção e evolução de marcas com identidade, posicionamento e comunicação consistentes.',
  },
]

export function Services() {
  return (
    <section id="servicos" className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <Reveal>
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <Kicker>Serviços</Kicker>
          <FluidHeading as="h2" className="text-3xl font-semibold text-white sm:text-5xl">
            Soluções que giram <span className="text-gradient">em torno do seu resultado</span>
          </FluidHeading>
          <p className="mt-4 text-white/55">
            Do anúncio à conversão, conectamos estratégia, criação e tecnologia para fazer sua empresa crescer no digital.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={i * 0.06}>
            <div
              className={`group relative h-full overflow-hidden rounded-2xl p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_0_0_1px_rgba(178,130,255,0.7),0_0_45px_-8px_rgba(139,60,240,0.95)] ${
                service.highlight
                  ? 'glow-border bg-gradient-to-br from-orb-600 to-orb-900'
                  : 'glass-card hover:border-orb-400/50'
              }`}
            >
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-orb-500/90 to-orb-900/90 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              {service.highlight && (
                <span className="absolute right-5 top-5 z-10 rounded-full bg-white/12 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-white/80">
                  Especialidade
                </span>
              )}
              <div
                className={`relative z-10 mb-5 flex h-11 w-11 items-center justify-center rounded-xl font-display text-sm font-semibold ${
                  service.highlight ? 'bg-white/15 text-white' : 'bg-white/10 text-orb-100'
                }`}
              >
                {String(i + 1).padStart(2, '0')}
              </div>
              <FluidHeading
                as="h3"
                className={`relative z-10 font-semibold text-white ${service.highlight ? 'text-xl' : 'text-lg'}`}
              >
                {service.title}
              </FluidHeading>
              <p className="relative z-10 mt-2.5 text-sm leading-relaxed text-white/60 transition-colors duration-500 group-hover:text-white/85">
                {service.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  )
}
